import React from "react";
import {MODES} from '../../../utils/constant'
import { getAirUnit } from '../../../utils/utility';
import I18n from "../../../localization";
import { useMobileStyles } from "./styles.js";

export const SMART='SMART'
export const MANUAL='MANUAL'

export const orderMap = {
  auto: 0,
  heat: 1,
  cool: 2,
  off: 3
};

export function getSliderMarksArray(centerValue) {
  const arr = new Array(9);
  const middleIndex = 4;
  const difference = getAirUnit() === "F" ? 1: 0.5;

  for (let i = 0; i < 9; i++) {
      // Calculate each value based on its offset from the middle index        
      arr[i] = centerValue + (i - middleIndex) * difference;
  }

  return arr;
}

export function getFanModeIcon(selectedFanMode, mode,isDarkMode) {
    if (selectedFanMode === mode) {
      if (mode === MODES.ON) {
        return `${MODES.ON.toLowerCase()}Enabled`;
      }
      if (mode === MODES.AUTO) {
        return isDarkMode ? 'auto' : `fanAutoEnabled`;
      }
      return isDarkMode ? `dark${mode.toLowerCase()}Enabled` : `${mode.toLowerCase()}Enabled`;
    }
    if (mode === MODES.ON) {
      return isDarkMode ? `dark${MODES.OFF.toLowerCase()}` : `${MODES.OFF.toLowerCase()}`;
    }
    return isDarkMode ? `dark${mode.toLowerCase()}` : `${mode.toLowerCase()}`;
  }

export  const getTempModeIcon = (isModeSelected, airMode,isDarkMode) => {
    if(isModeSelected) {
      return `${airMode.toLowerCase()}Enabled`
    }
    return isDarkMode ? `dark${airMode.toLowerCase()}` : airMode.toLowerCase()
  }

export const stopThumbs = (left,right,center,index,isFarenheit) => {

  const MIN_DISTANCE = isFarenheit ? 1 : 0.5
  
  if (index === 0 && left > center) {
      return true; 
    }
  
    // RIGHT thumb → hard stop at center
    if (index === 1 && right < center) {
      return true; 
    }
  
    // Prevent thumbs crossing each other
    if (right - left < MIN_DISTANCE) {
      return true; 
    }

    return false
  
};




export const getLimits= (range) => {
  return {
  heat_setpoint: {
    min: range?.min,
    max: range?.max
  },
  cool_setpoint: {
    min: range?.min,
    max: range?.max
  }
};
}

export const getSliderType = (availableModes = []) => {
  const modes = new Set(availableModes);

  const checkIfPresent = (...required) => required.every(m => modes.has(m));

  return {
    heatSlider: checkIfPresent(MODES.HEAT, MODES.OFF),
    coolSlider: checkIfPresent(MODES.COOL, MODES.OFF),
  };
};


export const getHalfMuliple = (num) => Math.floor(num * 2) / 2;

export const getSetpointStep = () => (getAirUnit() === 'F' ? 1 : 0.5);

export const getSetpointGap = () => (getAirUnit() === 'F' ? 3 : 1.5);

export const normalizeSetpointValue = (value, bounds = {}) => {
  const step = getSetpointStep();
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return numericValue;

  let normalized = Math.round(numericValue / step) * step;

  if (Number.isFinite(bounds.min)) {
    normalized = Math.max(normalized, bounds.min);
  }
  if (Number.isFinite(bounds.max)) {
    normalized = Math.min(normalized, bounds.max);
  }

  return Number(normalized.toFixed(step === 0.5 ? 1 : 0));
};

export const correctSetpointsForMode = ({ airMode, heat, cool, min, max }) => {
  const gap = getSetpointGap();
  const bounds = { min, max };

  let nextHeat = normalizeSetpointValue(heat, bounds);
  let nextCool = normalizeSetpointValue(cool, bounds);

  if (!Number.isFinite(nextHeat) || !Number.isFinite(nextCool)) {
    return {
      heat_setpoint: nextHeat,
      cool_setpoint: nextCool,
    };
  }

  if (airMode === MODES.AUTO && nextCool - nextHeat < gap) {
    const step = getSetpointStep();
    const mid = normalizeSetpointValue((nextHeat + nextCool) / 2, bounds);
    const rawHeat = mid - gap / 2;
    const rawCool = mid + gap / 2;
    nextHeat = Number((Math.floor(rawHeat / step) * step).toFixed(step === 0.5 ? 1 : 0));
    nextCool = Number((Math.ceil(rawCool / step) * step).toFixed(step === 0.5 ? 1 : 0));

    if (Number.isFinite(bounds.max) && nextCool > bounds.max) {
      nextCool = normalizeSetpointValue(bounds.max, bounds);
      nextHeat = Number((Math.floor((nextCool - gap) / step) * step).toFixed(step === 0.5 ? 1 : 0));
    }
    if (Number.isFinite(bounds.min) && nextHeat < bounds.min) {
      nextHeat = normalizeSetpointValue(bounds.min, bounds);
      nextCool = Number((Math.ceil((nextHeat + gap) / step) * step).toFixed(step === 0.5 ? 1 : 0));
    }
    if (Number.isFinite(bounds.min)) nextHeat = Math.max(nextHeat, bounds.min);
    if (Number.isFinite(bounds.max)) nextCool = Math.min(nextCool, bounds.max);
  }

  return {
    heat_setpoint: nextHeat,
    cool_setpoint: nextCool,
  };
};

export const ManualModeDescription = () => {
  return (
    <div>
      <div>{I18n.t("mobile.energyMode.manualModeDesc1")}</div>
      <div>{I18n.t("mobile.energyMode.manualModeDesc2")}</div>
    </div>
  );
};

export const SmartModeDescription = () => {
  const classes = useMobileStyles();

  const orderedItem = ({ heading, subHeadings }) => {
    return (
      <div>
        <div className={classes.subTitle}>{heading}</div>
        <ul className={classes.list}>
          {subHeadings.map((subItem) => (
            <li className={classes.listItem}>{subItem}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className={classes.smart_mode_description}>
      <div className={classes.smart_description_main}>
        <span
          dangerouslySetInnerHTML={{
            __html: I18n.t("mobile.energyMode.smartDescriptionMain"),
          }}
        ></span>
      </div>
      <div className={classes.separator}></div>
      {orderedItem({
        heading: I18n.t("mobile.energyMode.howItWorks"),
        subHeadings: [
          I18n.t("mobile.energyMode.smartDescriptionHowItWorks1"),
          I18n.t("mobile.energyMode.smartDescriptionHowItWorks2"),
          I18n.t("mobile.energyMode.smartDescriptionHowItWorks3"),
        ],
      })}
      <div className={classes.separator}></div>
      {orderedItem({
        heading: I18n.t("mobile.energyMode.comfortRange"),
        subHeadings: [
          I18n.t("mobile.energyMode.smartDescriptionComfortRange1"),
          I18n.t("mobile.energyMode.smartDescriptionComfortRange2"),
          I18n.t("mobile.energyMode.smartDescriptionComfortRange3"),
        ],
      })}
      {orderedItem({
        heading: I18n.t("mobile.energyMode.note"),
        subHeadings: [
          I18n.t("mobile.energyMode.smartDescriptionNote1"),
          I18n.t("mobile.energyMode.smartDescriptionNote2"),
        ],
      })}
    </div>
  );
};

export const ScheduledModeDescription = () => {
  const classes = useMobileStyles();

  return (
    <div className={classes.smart_mode_description}>
      <div className={classes.smart_description_main}>
        {I18n.t("mobile.iqAirSetting.scheduledMode.description")}
      </div>

      <div>
        <div className={classes.subTitle}>{I18n.t("mobile.iqAirSetting.scheduledMode.howItWorks")}</div>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            {I18n.t("mobile.iqAirSetting.scheduledMode.howItWorks1")}
          </li>
          <li className={classes.listItem}>
            {I18n.t("mobile.iqAirSetting.scheduledMode.howItWorks2")}
          </li>
          <li className={classes.listItem}>
            {I18n.t("mobile.iqAirSetting.scheduledMode.howItWorks3")}
          </li>
        </ul>
      </div>

      <div>
        <div className={classes.subTitle}>{I18n.t("mobile.iqAirSetting.scheduledMode.setUpSchedule")}</div>
        <ul className={classes.list}>
          <li className={classes.listItem}>{I18n.t("mobile.iqAirSetting.scheduledMode.setUpSchedule1")}</li>
          <li className={classes.listItem}>{I18n.t("mobile.iqAirSetting.scheduledMode.setUpSchedule2")}</li>
        </ul>
        <div>
          <em>{I18n.t("mobile.iqAirSetting.scheduledMode.timeBlockNote")}</em>
        </div>
      </div>

      <div>
        <div className={classes.subTitle}>{I18n.t("mobile.iqAirSetting.scheduledMode.note")}</div>
        <ul className={classes.list}>
          <li className={classes.listItem}>
            {I18n.t("mobile.iqAirSetting.scheduledMode.note1")}
          </li>
          <li className={classes.listItem}>
            {I18n.t("mobile.iqAirSetting.scheduledMode.note2")}
          </li>
        </ul>
      </div>
    </div>
  );
};

export const infoIconData = () => {
  return [
    {
      title: I18n.t("mobile.iqAirSetting.modes.smartMode"),
      id: 1,
      description: <SmartModeDescription />,
    },
    {
      title: I18n.t("mobile.iqAirSetting.modes.scheduledMode"),
      id: 2,
      description: <ScheduledModeDescription />,
    },
    {
      title: I18n.t("mobile.iqAirSetting.modes.manualMode"),
      id: 3,
      description: <ManualModeDescription />,
    },
  ];
};



